import { createContext, useContext, useState } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [usuario, setUsuario] = useState(() => {
    try { return JSON.parse(localStorage.getItem('usuario')); } catch { return null; }
  });
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState('');

  const login = async (user, password) => {
    setLoading(true); setError('');
    try {
      const { data } = await api.post('/auth/login', { usuario: user, password });
      localStorage.setItem('token', data.token);
      const userData = {
        usuario:        data.usuario,
        nombres:        data.nombres,
        tipo_usuario:   data.tipo_usuario   || '',
        especialidad:   data.especialidad   || '',
        roles:          data.roles          || [],
        esDBA:          data.esDBA          || false,
        esMedico:       data.esMedico       || false,
        esAdmisionista: data.esAdmisionista || false,
      };
      localStorage.setItem('usuario', JSON.stringify(userData));
      setUsuario(userData);
      return true;
    } catch (e) {
      setError(e.response?.data?.error || 'Error de conexion');
      return false;
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('usuario');
    setUsuario(null);
  };

  return (
    <AuthContext.Provider value={{ usuario, login, logout, loading, error }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
